import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";

export default function CategorySection() {
  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">
            <i className="ri-stack-line text-accent-500 mr-2"></i>
            内容分类导航
          </h2>
          <p className="mt-3 text-foreground-600 max-w-xl mx-auto text-sm">
            按需求快速定位，找到您需要的信息与帮助
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.id}
              to={`/category/${cat.slug}`}
              className="bg-background-50 border border-background-200/70 rounded-xl p-5 hover:border-primary-200 transition-all group cursor-pointer"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600 mb-3 group-hover:bg-primary-500 group-hover:text-white transition-all">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 text-sm mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 leading-relaxed line-clamp-2">
                {cat.description}
              </p>
              <div className="mt-3 flex items-center justify-between">
                <span className="text-xs text-foreground-400">{cat.articleCount} 篇文章</span>
                <i className="ri-arrow-right-line text-foreground-400 group-hover:text-primary-500 group-hover:translate-x-1 transition-all text-sm"></i>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}